import React from 'react';
import '../styles/global.scss';
import SEO from './SEO';
export default function Layout(props) {
  return (
    <>
      <SEO />
      <div style={{scrollBehavior: 'smooth'}}>{props.children}</div>
    </>
  )
}
